/**
 * Config: Classes
 * -----------------------------------------------------------------------------
 * Global configuration for Vue states and CSS classes.
 * - Add in alphabetical order.
 *
 */
export default {
  active: 'is-active',
  collapsed: 'is-collapsed',
  dark: 'is-dark',
  disabled: 'is-disabled',
  error: 'has-error',
  fixed: 'is-fixed',
  focusStyles: 'show-focus-styles',
  hidden: 'is-hidden',
  large: 'is-large',
  loading: 'is-loading',
  minimised: 'is-minimised',
  moved: 'is-moved',
  open: 'is-open',
  removed: 'is-removed',
  small: 'is-small',
  success: 'has-success',
  updating: 'is-updating',
  visible: 'is-visible',
}
